import {
  ICreateCustomerSettingRequest,
  IUpdateMetavalueRequest,
} from '../../types/api/request/customersettingsrequest';
import { IGetAllCustomerSettingsResponse } from '../../types/api/response/customersettingsresponse.d';
import { ICustomerSetting } from '../../types/store';
import axiosClient from '../axiosClient';
import { CustomerSettingsEndpoint } from '../endpoints/customerSettings';

export const CustomerSettingsService = {
  async getAllCustomerSettings(): Promise<IGetAllCustomerSettingsResponse> {
    const res = await axiosClient<IGetAllCustomerSettingsResponse>(
      CustomerSettingsEndpoint.GET_ALL_CUSTOMER_SETTINGS,
    );
    return res.data;
  },

  async updateMetavalue(payload: IUpdateMetavalueRequest): Promise<ICustomerSetting> {
    const url = CustomerSettingsEndpoint.UPDATE_METAVALUE.replace(':metakey', payload.metakey);
    const res = await axiosClient.post<ICustomerSetting>(url, { metavalue: payload.metavalue });

    return res.data;
  },

  async createCustomerSetting(payload: ICreateCustomerSettingRequest): Promise<ICustomerSetting> {
    const res = await axiosClient.post<ICustomerSetting>(
      CustomerSettingsEndpoint.CREATE_CUSTOMER_SETTING,
      payload,
    );

    return res.data;
  },
};
